import dayjs from 'dayjs';

export const formatTemplate = 'YYYY/MM/DD';

export const formatDate = (date: string | null): string =>
  date ? dayjs(date).format(formatTemplate) : '...';

export const getDateNow = (): string => formatDate(dayjs().toISOString());
